import { useQueryClient } from '@tanstack/react-query';
import { Loader } from '@unistocks/components/loading/spinner/loader';
import { Page } from '@unistocks/components/page/page';
import { toast } from '@unistocks/components/toast';
import {
  sharedPortfoliosGetListQueryKey,
  useSharedPortfoliosAcceptSharedPortfolioMutationWithParameters
} from '@unistocks/proxy/axios-client/SharedPortfoliosQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { isHandledError } from '@unistocks/shared/utils/error';
import { useFocusEffect, useLocalSearchParams, useRouter } from 'expo-router';
import { useCallback } from 'react';

type Params = {
  accept: string;
};

export const AcceptSharedPortfolio = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { accept } = useLocalSearchParams<Params>();

  const { mutate: acceptShare } = useSharedPortfoliosAcceptSharedPortfolioMutationWithParameters({
    retry: false
  });

  useFocusEffect(
    useCallback(() => {
      if (accept) {
        acceptShare(
          { id: accept },
          {
            onSuccess: res => {
              queryClient.invalidateQueries({
                queryKey: sharedPortfoliosGetListQueryKey()
              });
              router.replace(
                {
                  pathname: '/(tabs)/portfolios/shared/[id]',
                  params: { id: res.id }
                },
                {
                  withAnchor: true
                }
              );
            },
            onError: e => {
              if (!isHandledError(e)) {
                toast.error(t('::Portfolio:Share:AcceptShare:Error:Title'), {
                  description: t('::Portfolio:Share:AcceptShare:Error:Message')
                });
              }

              router.replace('/');
            }
          }
        );
      } else {
        router.replace('/');
      }
    }, [accept, acceptShare, queryClient, router])
  );

  return (
    <Page>
      <Page.ScrollView headerLogo headerBackArrow={false} headerNotificationIcon={false}>
        <Loader fullscreen>{t('::Portfolio:Share:AcceptingShare')}</Loader>
      </Page.ScrollView>
    </Page>
  );
};

AcceptSharedPortfolio.displayName = 'AcceptSharedPortfolio';
